import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Input} from '@angular/core';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-search-slim',
  templateUrl: './search-slim.component.html',
  styles: []
})
export class SearchSlimComponent extends ExcTranslation implements OnInit {

  @Input() searchField;
  @Input() debounce = 300;
  @Output() searchChanged: EventEmitter<SearchSlimData> = new EventEmitter<SearchSlimData>();
  @Input() searchKeypress = true;
  searchValue = '';
  timeout = null;
  isDefaultSearch = false;
  searchOptions: any[] = [];
  constructor(private excDss: DefaultSettingsService) {
  super();
  }

  setValue(event) {
    this.raiseChange(false);
  }
  handleKeyPress(event) {
    if (event.code === 'Enter') {
      this.raiseChange(true);
    }
  }
  handleSelectionChanged(e) {
    // this.searchValue = e;
    this.searchValue = (<HTMLSelectElement>event.target).selectedOptions[0].value;
    this.raiseChange(true);
  }
  raiseChange(immediate) {
    const _self = this;
    if (_self.searchKeypress === false) {
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      if (immediate) {
        _self.searchChanged.emit(new SearchSlimData(this.searchField, this.searchValue));
      } else {
        this.timeout = setTimeout(() => {
          _self.searchChanged.emit(new SearchSlimData(this.searchField, this.searchValue));
        }, this.debounce);
      }
    } else {
      if (immediate) {
        _self.searchChanged.emit(new SearchSlimData(this.searchField, this.searchValue));
      }
    }
  }

  ngOnInit() {
    if (this.excDss.Defaults[this.searchField] !== undefined && this.excDss.Defaults[this.searchField].length > 0) {
      this.searchOptions.push({text: '', value: ''});
      for (const x of this.excDss.Defaults[this.searchField]) {
        this.searchOptions.push({text: x, value: x});
      }
    }
    this.isDefaultSearch = this.searchOptions.length > 0;
  }
}
export class SearchSlimData {
  field: string = null;
  value: string = null;
  constructor(field: string, value: string) {
    this.field = field;
    this.value = value;
  }
}
